import { Component, OnInit, Input } from '@angular/core';
import { RoleCheckerService } from '../../../services/role-checker.service';
import { CommonService } from '../../../services/common.service';
import { JwtService } from 'src/app/services/jwt.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-vehicle-dt-indexes',
  templateUrl: './vehicle-dt-indexes.component.html',
  styleUrls: ['./vehicle-dt-indexes.component.scss']
})
export class VehicleDtIndexesComponent implements OnInit {

  @Input() vehicle: any
  @Input() type: string;
  permissions: Array<string> = [];
  public showRvValues: boolean = true;
  constructor(
    public roleCheckService: RoleCheckerService,
    public commonService: CommonService,
    private jwtService: JwtService,
    private router: Router) {

  }

  ngOnInit() {
    // Get the current route
    const currentRoute = this.router.url;
    this.permissions = this.jwtService.getUserPermissions();

    if (!this.roleCheckService.isSuperAdmin() && (currentRoute == '/vehicle-list-new' && !this.permissions.includes('new_edit_rv')) ||
      (currentRoute == '/vehicle-list-used' && !this.permissions.includes('used_edit_rv'))) {
      this.showRvValues = false;
    } else {
      this.showRvValues = true;
    }
  }


}
